module.exports = __webpack_public_path__ + "img/practice.57532cf3.svg";